// Lender channel registry: each lender's business channel (Wholesale / Retail /
// Both), from LANIS Lender List V1.4. Drives the brokered-loan sublist (only
// Wholesale + Both lenders can be a 'brokered to' destination).
const LENDER_CHANNELS = Object.freeze({
  "A&D Mortgage": "Both",
  "Acra Lending": "Wholesale",
  "Am Financial Network": "Both",
  "Am Heritage Lending": "Both",
  "Am Pacific Mort.": "Retail",
  "AmeriHome": "Retail",
  "AnnieMac": "Retail",
  "Atlantic Bay": "Retail",
  "Atlantic Coast": "Retail",
  "Better Mortgage": "Retail",
  "Canopy Mortgage": "Retail",
  "Carrington Mortgage": "Both",
  "Change Lending": "Both",
  "Churchill Mort.": "Retail",
  "CMG Home Loans": "Both",
  "Cornerstone": "Retail",
  "Cornerstone First": "Retail",
  "CrossCountry": "Retail",
  "Fairway Independent": "Both",
  "FBC Mortgage": "Both",
  "First Community": "Both",
  "First Home Mortgage": "Retail",
  "First Natl Bank Amer": "Both",
  "First United Bank": "Retail",
  "GMFS Mortgage": "Both",
  "Guar. Rate Affinity": "Retail",
  "Guild Mortgage": "Retail",
  "Highlands Res.": "Retail",
  "Homeowners Fin.": "Retail",
  "Intercap Lending": "Retail",
  "KBHS Home Loans": "Retail",
  "Kind Lending": "Both",
  "Leader Bank": "Retail",
  "LeaderOne Fin.": "Both",
  "loanDepot": "Retail",
  "Luminate Bank": "Retail",
  "Movement Mortgage": "Retail",
  "Mutual of Omaha": "Both",
  "Nations Lending": "Retail",
  "Neighborhood Loans": "Retail",
  "New American Fund": "Retail",
  "Newrez": "Both",
  "NexBank": "Both",
  "NFM Lending": "Retail",
  "NJ Lenders": "Retail",
  "Northpointe Bank": "Retail",
  "NOVA Home Loans": "Retail",
  "OCMBC": "Wholesale",
  "OMG Home Loans": "Retail",
  "OriginPoint": "Retail",
  "Pennymac": "Both",
  "Planet Home Lend.": "Retail",
  "Plaza Home Mort.": "Wholesale",
  "PMRI": "Retail",
  "PrimeLending": "Retail",
  "PRMG": "Both",
  "Prosperity Home": "Both",
  "Rate": "Retail",
  "Revolution Mortgage": "Retail",
  "Ruoff Mortgage": "Retail",
  "Service First": "Wholesale",
  "Supreme Lending": "Retail",
  "SWBC": "Retail",
  "theLender": "Both",
  "TowneBank Mortgage": "Retail",
  "USA Mortgage": "Both",
  "UWM": "Wholesale",
  "V.I.P. Mortgage": "Both",
  "Waterstone Mort.": "Retail",
  "Wintrust Mortgage": "Retail",
});

export default LENDER_CHANNELS;

// Lenders that can receive a brokered loan (wholesale-capable).
export const WHOLESALE_LENDERS = Object.freeze(
  Object.keys(LENDER_CHANNELS).filter(n => {
    const c = LENDER_CHANNELS[n];
    return c === "Wholesale" || c === "Both";
  })
);
